'use strict';

module.exports = require('./lib/React');



/** WEBPACK FOOTER **
 ** ./~/react/react.js
 **/